/**
 * Arabic count agreement helper.
 *
 * Arabic has no single plural: 1 takes the singular plus «واحد/وحدة», 2 the
 * dual, 3–10 the plural, and 11 and up the singular again. The caller supplies
 * the four phrase forms; the helper prepends the number where Arabic needs it
 * (Latin digits only, per the project digit rule).
 */
export type ArCountForms = {
  /** Exactly 1 — includes the واحد/وحدة word itself, e.g. «سؤال واحد». */
  one: string;
  /** Exactly 2 — the dual, e.g. «سؤالين». */
  two: string;
  /** 3–10 — the plural without the number, e.g. «أسئلة». */
  few: string;
  /** 11 and up (and 0) — the singular without the number, e.g. «سؤال». */
  many: string;
};

export function arCount(n: number, forms: ArCountForms): string {
  const safe = Math.trunc(n);
  if (safe === 1) return forms.one;
  if (safe === 2) return forms.two;
  if (safe >= 3 && safe <= 10) return `${safe} ${forms.few}`;
  return `${safe} ${forms.many}`;
}
